<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="name" >
        <span slot="label" ><a-tooltip>{{$t('活动名称')}}<template slot="title">{{$t('活动名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.name" :maxLength="100" :placeholder="$t('请输入')+'活动名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="startTime" >
        <span slot="label" ><a-tooltip>{{$t('开始时间')}}<template slot="title">{{$t('开始时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" ><a-tooltip>{{$t('结束时间')}}<template slot="title">{{$t('结束时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('状态')}}<template slot="title">{{$t('状态')}}</template></a-tooltip> </span>
        <a-radio-group v-model="form.status" style="width: 100%">
          <a-radio :value="1">{{$t('启用')}}</a-radio>
          <a-radio :value="0">{{$t('禁用')}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getLotteryActivity, addLotteryActivity, updateLotteryActivity } from '@/api/lottery/lotteryActivity'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        startTime: null,
        endTime: null,
        status: 0,
        createdAt: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          name: [{ required: true, message: this.$t('活动名称')+this.$t('不能为空'), trigger: 'blur' }] ,
          startTime: [{ required: true, message: this.$t('开始时间')+this.$t('不能为空'), trigger: 'blur' }] ,
          endTime: [{ required: true, message: this.$t('结束时间')+this.$t('不能为空'), trigger: 'blur' }] ,
          status: [{ required: true, message: this.$t('1启用 0关闭')+this.$t('不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        startTime: null,
        endTime: null,
        status: 0,
        createdAt: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLotteryActivity({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateLotteryActivity(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLotteryActivity(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
